var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIvgLogoVerticalWhiteVersionWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 382.7 212.6",
    style: {
      enableBackground: "new 0 0 382.7 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 382.7,
    height: 212.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Marchi"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.4,126.9c6-0.2,11.8,2,16.1,6.2c4.2,3.9,6.6,9.5,6.5,15.3c0.1,5.8-2.2,11.4-6.5,15.3c-4.3,4-9.8,6-16.4,6 c-5.8,0.2-11.5-2-15.7-6c-4.1-3.9-6.4-9.4-6.3-15.1c-0.2-5.8,2.1-11.4,6.3-15.4C184.6,128.9,190,126.9,196.4,126.9z M196.7,132.5 c-4.4-0.2-8.6,1.5-11.8,4.5c-3.1,3-4.8,7.1-4.6,11.4c-0.1,4.2,1.6,8.3,4.6,11.2c6.6,6,16.7,6,23.3-0.1c3.1-3,4.8-7.1,4.7-11.4 c0.1-4.2-1.6-8.3-4.7-11.2C205.1,134,200.9,132.4,196.7,132.5L196.7,132.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279.3,127.4h6v23.7c0.1,2.4-0.2,4.9-0.7,7.2c-0.4,1.4-1,2.8-1.7,4.1c-0.7,1.1-1.5,2.1-2.5,2.9 c-3.3,2.8-7.7,4.3-13,4.3c-5.3,0-9.7-1.4-13.1-4.2c-1-0.9-1.8-1.8-2.5-2.9c-0.8-1.2-1.3-2.6-1.7-4c-0.5-2.4-0.8-4.9-0.7-7.4v-23.6 h6v23.7c0,3.9,0.4,6.6,1.3,8.2c1,1.6,2.4,2.9,4.1,3.7c2,1,4.2,1.4,6.5,1.4c3.1,0.1,6.2-0.8,8.7-2.8c1.1-0.9,2-2.1,2.5-3.5 c0.6-2.3,0.9-4.6,0.8-7V127.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M319.5,169.3v-41.9h15.1c4,0,7.2,1.1,9.5,3.2c2.4,2.2,3.7,5.4,3.5,8.6c0,2.3-0.6,4.5-1.8,6.4 c-1.2,1.9-2.9,3.3-5,4.1c-2.9,1-6,1.4-9.1,1.3h-6.3v18.2L319.5,169.3z M333.6,132.7h-8.1v13h8.4c2,0.1,4-0.5,5.6-1.7 c1.4-1.3,2.1-3.1,2-4.9C341.5,134.8,338.9,132.7,333.6,132.7L333.6,132.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 196.5,
    cy: 101.5,
    rx: 8.4,
    ry: 8.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.8,169.3l-13.1-20.7c1.5-0.8,2.8-1.9,3.7-3.3c1.2-1.9,1.9-4.1,1.8-6.3c0.1-3.2-1.2-6.4-3.7-8.5 c-2.5-2.1-5.8-3.1-10.1-3.1h-11.6v41.9h6v-36.8h1.8c2.5-0.1,5,0.1,7.4,0.6c1.2,0.4,2.3,1.2,3,2.2c0.7,1.1,1,2.3,1,3.6 c0,1.3-0.3,2.5-0.9,3.6c-0.6,1-1.5,1.9-2.6,2.4c-1.3,0.5-2.7,0.7-4.1,0.7l14.9,23.7L149.8,169.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.5,148.6h11.4v17.7c-4.8,2.2-10,3.3-15.3,3.3c-6.9,0-12.4-2-16.6-6c-4.1-3.9-6.3-9.3-6.2-14.9 c-0.2-5.9,2.2-11.5,6.4-15.5c4.3-4.1,10.1-6.4,16.1-6.2c2.3,0,4.5,0.2,6.7,0.8c2.7,0.7,5.4,1.6,8,2.8v6.1 c-4.5-2.7-9.6-4.2-14.8-4.3c-4.3-0.1-8.5,1.6-11.5,4.6c-6.2,6.4-6.2,16.6,0,23c3.3,3.1,7.6,4.7,12.1,4.5c2.9-0.1,5.8-0.7,8.6-1.6 l0.6-0.2v-8.7h-8.8L68.5,148.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.5,33.3h6v41.9h-6V33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.3,33.3h6l-17.7,41.8h-1.3l-18-41.8h6l12.6,29.3L121.3,33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M325.2,32.7c6-0.2,11.8,2,16.1,6.1c4.2,4,6.6,9.5,6.4,15.3c0.1,5.8-2.2,11.4-6.5,15.3c-4.3,4-9.8,6-16.4,6 c-5.8,0.2-11.5-2-15.7-6c-4.1-3.9-6.4-9.4-6.3-15.1c-0.2-5.8,2.1-11.4,6.3-15.5C313.4,34.8,318.7,32.7,325.2,32.7z M325.4,38.4 c-4.4-0.2-8.6,1.5-11.8,4.5c-3.1,3-4.8,7.1-4.6,11.4c-0.1,4.2,1.6,8.3,4.6,11.2c6.6,6,16.7,6,23.2-0.1c3.1-3,4.8-7.1,4.7-11.4 c0.1-4.2-1.6-8.3-4.7-11.1C333.8,39.9,329.7,38.3,325.4,38.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.2,65.7c-4.3,2.8-9.2,4.3-14.3,4.3c-4.4,0.1-8.7-1.4-11.9-4.4c-3.1-2.9-4.8-7-4.7-11.3 c-0.1-4.3,1.6-8.4,4.7-11.3c3.2-3,7.5-4.7,11.9-4.5c5,0.1,9.9,1.5,14.2,4.1v-6.4c-4.6-2.1-9.5-3.2-14.5-3.4 c-5.9-0.1-11.7,2.1-16,6.2c-4.3,3.9-6.6,9.5-6.5,15.3c0,3.7,0.9,7.4,2.8,10.7c1.8,3.2,4.5,5.9,7.7,7.7c3.6,2,7.7,2.9,11.9,2.8 c5.1,0.1,10.1-1,14.7-3.3V65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.4,33.3h26.4l-3.4,5.3h-17.1v13h17V57h-17v13h19.9v5.3h-25.9V33.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvgLogoVerticalWhiteVersionWeb);
export default __webpack_public_path__ + "static/media/IVG_Logo_Vertical_White_Version_Web.ae8d9fe2606dadc951543d77199b9d9a.svg";
export { ForwardRef as ReactComponent };